define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');
    const core = require('core');
    const user = require('user');
    const server = require('server');
    const config = require('config');
    const dynamicTagsUtil = require('util/codere-theme/dynamic-tags.util');
    const userValidationConfig = require('modules/user/user.validation.config');

    module.exports = () => {
        var initConfig = userValidationConfig();
        const PHONE_DUPLICITYCHECK = 'PHONE_DUPLICITYCHECK';
        const EMAIL_DUPLICITYCHECK = 'EMAIL_DUPLICITYCHECK';

        return {
            ...initConfig,
            registerEmail: {
                ajax: {
                    fn: (function() {
                        let prevValue;

                        return function ajax($inputs, conf, form, dfd) {
                            let token = user.get('emailAvailabilityVerificationToken');
                            let value = $inputs.val();
                            let INTERNAL_EMAIL = 'test@playtech.com';
                            let isInternalEmail = value === INTERNAL_EMAIL;
                            let emailDuplicityCheckTag = dynamicTagsUtil.getDynamicTag(EMAIL_DUPLICITYCHECK);

                            if (prevValue === value) {
                               return dfd.resolve();
                            }

                            if (!isInternalEmail && emailDuplicityCheckTag && emailDuplicityCheckTag === '1') {
                                server.send({
                                    ID: 31003,
                                    description: 'Checks if email is available',
                                    responses: [31004, 33007],
                                    email: value,
                                    casinoName: config.get('casinoName'),
                                    ...token && { token }
                                }).done(function(response) {
                                    const { data: { emailAvailable } } = response;

                                    if (emailAvailable === 'available' || emailAvailable === 'unknown') {
                                        prevValue = value;

                                        dfd.resolve(response);
                                    } else {
                                        dfd.reject({
                                            message: [
                                                i18n.t('playtech.mobile.system.user.tooltip.email.occupied')
                                            ].filter(Boolean).join(' ')
                                        });
                                    }
                                }).fail(function(response) {
                                    const { data: { errorCode, errorMessage } } = response;

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(response);
                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('emailAvailabilityVerificationToken', verificationToken);

                                                        ajax($inputs, conf, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: errorMessage });
                                        }
                                    }
                                });
                            } else {
                                dfd.resolve();
                            }
                            return dfd;
                        };
                    })()
                }
            },
            cellphone: {
                ajax: {
                    fn: (function() {
                        let prevValue;

                        return function ajax($inputs, conf, form, dfd) {
                            let token = user.get('cellphoneAvailabilityVerificationToken');
                            let cellphonePrefix = form.$el.find('.fieldset_name_cellphonePrefix .field').html();
                            let phone = `${cellphonePrefix}${$inputs.val()}`;
                            let phoneDuplicityCheckTag = dynamicTagsUtil.getDynamicTag(PHONE_DUPLICITYCHECK);

                            if (prevValue === phone) {
                                return dfd.resolve();
                            }

                            if (phoneDuplicityCheckTag && phoneDuplicityCheckTag === '1') {
                                server.send({
                                    ID: 31003,
                                    description: 'Checks if phone is available',
                                    responses: [31004, 33007],
                                    phone: phone,
                                    casinoName: config.get('casinoName'),
                                    ...token && { token }
                                }).done(function(response) {
                                    const { data: { phoneAvailable } } = response;

                                    if (phoneAvailable) {
                                        prevValue = phone;

                                        dfd.resolve(response);
                                    } else {
                                        dfd.reject({
                                            message: [
                                                i18n.t('playtech.mobile.system.user.tooltip.phone.occupied')
                                            ].filter(Boolean).join(' ')
                                        });
                                    }
                                }).fail(function(response) {
                                    const { data: { errorCode, errorMessage } } = response;

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(response);
                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('cellphoneAvailabilityVerificationToken', verificationToken);

                                                        ajax($inputs, conf, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: errorMessage });
                                        }
                                    }
                                });
                            } else {
                                dfd.resolve();
                            }

                            return dfd;
                        };
                    })()
                }
            },
            cellphoneValidation: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.required')
                },
                regexp: {
                    regexp: /^\+\d{12}$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.state.regexp')
                },
                ajax: {
                    fn: (function() {
                        let prevValue;

                        return function ajax($inputs, conf, form, dfd) {
                            let token = user.get('cellphoneAvailabilityVerificationToken');
                            let phoneDuplicityCheckTag = dynamicTagsUtil.getDynamicTag(PHONE_DUPLICITYCHECK);
                            let cellPhoneFieldValue = $inputs[0].value;
                            let userCellPhone = user.get('userDetails').cellphone;

                            if (cellPhoneFieldValue === userCellPhone || prevValue === cellPhoneFieldValue) {
                                return dfd.resolve();
                            }

                            if (phoneDuplicityCheckTag && phoneDuplicityCheckTag === '1') {
                                server.send({
                                    ID: 31003,
                                    description: 'Checks if phone is available',
                                    responses: [31004, 33007],
                                    phone: $inputs[0].value,
                                    casinoName: config.get('casinoName'),
                                    ...token && { token }
                                }).done(function(response) {
                                    const { data: { phoneAvailable } } = response;

                                    if (phoneAvailable) {
                                        prevValue = cellPhoneFieldValue;

                                        dfd.resolve(response);
                                    } else {
                                        dfd.reject({
                                            message: [
                                                i18n.t('playtech.mobile.system.user.tooltip.phone.occupied')
                                            ].filter(Boolean).join(' ')
                                        });
                                    }
                                }).fail(function(response) {
                                    const { data: { errorCode, errorMessage } } = response;

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(response);
                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('cellphoneAvailabilityVerificationToken', verificationToken);

                                                        ajax($inputs, conf, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: errorMessage });
                                        }
                                    }
                                });
                            } else {
                                dfd.resolve();
                            }

                            return dfd;
                        };
                    })()
                }
            },
            cellphoneVerification: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneVerificationCode.required')
                },
                length: {
                    min: 4,
                    max: 10,
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneVerificationCode.length')
                }
            }
        };
    };
});
